import styled from 'styled-components';

export const FacesStyled = styled.div`
  width: 100%;
  margin-top: 50px;

  & p {
    font-weight: 500;
  }
`;

export const ContainerStyled = styled.div`
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  padding: 0 16px;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 1300px;
    gap: 50px;
  }

  .main-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    & .heading {
      font-size: 18px;
      line-height: 32px;
      font-weight: bold;
      text-align: center;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 24px;
        line-height: 29.05px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 32px;
        line-height: 38.73px;
      }
    }
  }

  .faces {
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-template-columns: 1fr 1fr;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      grid-template-columns: 1fr 1fr 1fr;
      gap: 80px;
    }
  }
`;

export const FacesDetailsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .profile {
    display: flex;
    gap: 12px;

    & .img {
      height: 70px;
      width: 70px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        height: 100%;
        width: 100%;
      }
    }
  }

  .background {
    background-color: ${({ theme }) => theme.colors.lightBackground};
    padding: 20px 10px;
    border-radius: 10px;
  }
`;
